// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Popover, PopoverContainer, Base, Svg } from '@gandi/ui';

import { useAppSelector } from 'src/hooks';

import {
  selectCorporatePackMonthlyCurrency,
  selectCorporatePackMonthlyPrice,
} from '../../modules/app/selectors/corporatePack';

import styles from './CorporatePopOver.scss';

type Props = {
  id: string,
};

const popoverIconModifiers = [
  {
    name: 'flip',
    options: {
      // This means, prefer the bottom placement,
      // but allow repositioning on all sides, not just top.
      allowedAutoPlacements: ['bottom', 'top', 'left', 'right'],
    },
  },
];

function CorporatePopOver({ id }: Props): React.Node {
  const translator = useTranslator();
  const corporatePackMonthlyPrice = useAppSelector(
    selectCorporatePackMonthlyPrice,
  );

  const currency = useAppSelector(selectCorporatePackMonthlyCurrency);

  const message = translator.__(
    'Due to special registry rules, registering this extension ' +
      'needs some additional work on the part of our team. ' +
      'For this reason, purchasing it requires you to subscribe ' +
      'to our Corporate Pack. This subscription costs %(price)s ' +
      'for one month and will be automatically added to your cart ' +
      "if you aren't already a subscriber. Any domain names " +
      'you acquire remain yours and can always be renewed, ' +
      'even after the Corporate subscription ends.',
    {
      price:
        corporatePackMonthlyPrice !== undefined
          ? translator.formatPrice(corporatePackMonthlyPrice, currency)
          : '...',
    },
  );

  return (
    <PopoverContainer
      id={id}
      placement="bottom"
      modifiers={popoverIconModifiers}
      renderReference={getReferenceProps => (
        <Base
          {...getReferenceProps()}
          className={styles.corporateIconContainer}
        >
          <Svg name="badgeCorporateWire" className={styles.corporateIcon} />
        </Base>
      )}
    >
      {getPopoverProps => (
        <Popover {...getPopoverProps()} className={styles.corporatePopover}>
          <Base
            tagName="p"
            margin="none"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </Popover>
      )}
    </PopoverContainer>
  );
}

export default (React.memo<Props>(
  CorporatePopOver,
): React.ComponentType<Props>);
